import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Participation } from './Participation.js';
import type { ParticipationEinzelberatung } from './ParticipationEinzelberatung.js';
import { UserStammdaten } from './stammdaten.js';
import { User } from './user.js';

@Entity()
export class ParticipationExportCSV extends AdornisEntity {
  static override _class = 'ParticipationExportCSV';

  @Field(type => User) user!: User;
  @Field(type => Participation) participation!: Participation;
  @Field(type => UserStammdaten) stammdaten!: UserStammdaten;
}

@Entity()
export class ParticipationEinzelberatungExportCSV extends AdornisEntity {
  static override _class = 'ParticipationEinzelberatungExportCSV';

  @Field(type => User) user!: User;
  @Field(type => User) berater?: User;
  @Field(type => UserStammdaten) stammdaten!: UserStammdaten;
  @Field(type => Participation) participation!: ParticipationEinzelberatung;
}
